// src/api/apiSlice.js
import {
  BaseQueryFn,
  FetchArgs,
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { AppState } from 'src/store/Store';
import { FederationsPermissions } from 'src/types/apps/permissions';

// get params from url here

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL_GENERAL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const state = getState() as AppState;
    const user = state.authReducer.user;
    const permissions = state.permissionsReducer.permissions;

    // If we have a token set in state, let's assume that we should be passing it.
    if (user?.token) {
      headers.set('authorization', `Bearer ${user.token}`);
    }

    if (!user?.token) {
      //get token from url ?token=ejhs
      const token = window.location.pathname.split('Barear')?.[1];

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
    }

    // Set language to expect localized content
    // headers.set('X-Locale', I18nManager.isRTL ? 'ar' : 'en')

    if (endpoint === 'generateLink') {
      headers.set('App-Platform', 'player');
    } else {
      headers.set('App-Platform', 'malaeb-business');
    }

    headers.set('accept', 'application/json');

    // Inject federation credentials for federation users
    const isFederation = permissions?.some(
      (perm) =>
        perm?.name === FederationsPermissions.TOURNAMENTS_VIEW ||
        perm?.name === FederationsPermissions.TOURNAMENTS_VIEW_ORGANIZER,
    );
    if (isFederation) {
      const apiKey = process.env.REACT_APP_FEDERATION_API_KEY;
      const apiSecret = process.env.REACT_APP_FEDERATION_API_SECRET;
      if (apiKey) headers.set('x-api-key', apiKey);
      if (apiSecret) headers.set('x-api-secret', apiSecret);
    }

    return headers;
  },
});

const baseQueryWithInterceptor: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  console.debug(result);

  // const status = result.meta?.response?.status

  // if (status && status >= 400) {
  //   Sentry.sentryErrorHandler(
  //     result.error?.data,
  //     result.meta?.response?.status,
  //     result?.meta?.request?.method,
  //     result?.meta?.request?._bodyInit,
  //   )
  // }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}),
});
